import axios from 'axios';

export const http = {
    get(url, params) {
        return axios.get(url, {
            params: params
        })
    },

    post(url, params) {
        return axios.post(url, params)
    },

    init() {
        window.axios = axios;
        axios.defaults.baseURL = window.app.baseUrl;
        window.axios.defaults.headers.common = {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        };

        // Intercept the response and…
        axios.interceptors.response.use(response => {
            return response;
        }, error => {
            return Promise.reject(error);
        })
    }
}
